// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3WbFm","alertIcon":"ConfirmModal_alertIcon__30d9L"};